import { render, staticRenderFns } from "./mergecorpusDialog.vue?vue&type=template&id=313c012a&scoped=true&"
import script from "./mergecorpusDialog.vue?vue&type=script&lang=js&"
export * from "./mergecorpusDialog.vue?vue&type=script&lang=js&"
import style0 from "./mergecorpusDialog.vue?vue&type=style&index=0&id=313c012a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c012a",
  null
  
)

export default component.exports